import { URI } from '../../constants/URI';
import { handlePostRequest } from '.';

export const sendUserCreds = async (payload) => {
  const res = await handlePostRequest(URI.user_creds, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendNewAccountEmail = async (payload) => {
  const res = await handlePostRequest(URI.new_account, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendAccountApprovedEmail = async (payload) => {
  const res = await handlePostRequest(URI.account_approved, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendPasswordChangedEmail = async (payload) => {
  const res = await handlePostRequest(URI.password_changed, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendResetPasswordEmail = async (payload) => {
  const res = await handlePostRequest(URI.reset_password_email, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendStoreAssignedEmail = async (payload) => {
  const res = await handlePostRequest(URI.store_assigned, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendTaskAssignedEmail = async (payload) => {
  const res = await handlePostRequest(URI.task_assigned, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendTaskCompletedEmail = async (payload) => {
  const res = await handlePostRequest(URI.task_completed, payload, {
    toast: false,
    loading: false,
  });
  return res;
};

export const sendUndoTaskCompletionEmail = async (payload) => {
  const res = await handlePostRequest(URI.undo_task, payload, {
    toast: false,
    loading: false,
  });
  return res;
};
